module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point3_1-c04f67ef3d7390968b085796e00f05ca.jpg";